import { useAtsCandidateFormTrackVacancyVisitMutation } from './graphql/track-vacancy-visit.v5.generated';

export const useTrackVacancyVisit = () =>
  useAtsCandidateFormTrackVacancyVisitMutation({
    context: {
      clientName: 'v5',
    },
  });
